import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import { Table } from 'antd';

const VirtualTable = forwardRef((props, ref) => {
  const tableRef = useRef(null);

  useImperativeHandle(ref, () => ({
    scrollToRow: (serialNumber) => {
      setTimeout(() => {
        const row = document.querySelector(`.ant-table-row[data-row-key="${serialNumber}"]`);
        if (row) {
          row.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }, 150);
    },
  }));

  return (
    <Table
      {...props}
      ref={tableRef}
      pagination={false}
      scroll={{ y: 'calc(100vh - 350px)', x: 'calc(100vh - 350px)', virtual: true }}
      style={{ width: '100%' }}
    />
  );
});

export default VirtualTable;
